/**
 * AudioResults Component
 *
 * Audio player and reset button for generated audio.
 */

import { memo } from 'react';
import { AudioPlayer } from '../../components/AudioPlayer';
import type { AudioGenerationResponse } from '../../types';
import type { AudioJobResult } from '../../services/polling/audioPollAdapter';

interface AudioResultsProps {
  url: string;
  metadata: AudioGenerationResponse;
  /** Re-read the job for freshly signed links (see useAudioGeneration.refreshResult). */
  refreshResult: () => Promise<AudioJobResult>;
  onReset: () => void;
}

export const AudioResults = memo(function AudioResults({
  url,
  metadata,
  refreshResult,
  onReset,
}: AudioResultsProps) {
  return (
    <div data-testid="result-container">
      <AudioPlayer url={url} metadata={metadata} refreshResult={refreshResult} />

      {/* Reset Button */}
      <div className="mt-4 flex justify-center">
        <button onClick={onReset} className="btn-secondary px-6 py-2" data-testid="reset-button">
          Generate Another Audio
        </button>
      </div>
    </div>
  );
});
